import React from 'react';

/**
 * Gallery — grille responsive d'images avec légende TOUJOURS visible
 * (nom + fonction), conforme RGAA (information non réservée au survol).
 */
function Gallery({ images }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
      {images?.map((image, index) => (
        <div
          key={index}
          className="relative group overflow-hidden rounded-2xl card-surface ring-gradient aspect-[4/5]"
        >
          <img
            src={image.image}
            alt={image.titre}
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          />
          <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-[#0a0218] via-[#0a0218]/70 to-transparent">
            <h3 className="font-display font-bold text-white leading-tight">{image.titre}</h3>
            {image.text && <p className="text-sm text-[#cbbef0] mt-0.5">{image.text}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Gallery;
